<template>
    <div class="loading-progress">
        <ProgressBar :value="percentage" />
<!--        <Skeleton height="20rem" />-->
    </div>
</template>

<script>
    import ProgressBar from 'primevue/progressbar';
    // import Skeleton from 'primevue/skeleton';

    export default {
        name: 'CheckerLoadingProgress',
        props: {
            percentage: {
                type: Number,
                required: true,
            }
        },
        components: {
            ProgressBar,
            // Skeleton
        }
    }
</script>